export default __webpack_public_path__ + "files/code_themes/6a81c4fa43cfb60d98c5f3484f0cad8f.css";